import { Component, OnInit, Input, OnChanges, SimpleChanges, ViewChild, OnDestroy } from '@angular/core';
import { DatosFechasService } from '../../../services/datos-fechas.service';
import { GruposLiquidacionService } from '../../../services/gruposLiquidacion.service';
import { SpinnerService } from "app/services/spinner.service";
import { DatosOrganizativosComponent } from '../datos-organizativos/datos-organizativos.component';
import { DireccionesComponent } from '../direcciones/direcciones-cab/direcciones.component';
import { FamiliaresComponent } from '../familiares/familiares-cab/familiares.component';
import { InfoIdentidadCabComponent } from '../infoIdentidad/info-identidad-cab/info-identidad-cab.component';
import { DatosFechasCabComponent } from '../datosFechas/datos-fechas-cab/datos-fechas-cab.component';
import { ContratosComponent } from '../contratos/contratos.component';
import { DatosBancoComponent } from '../datos-banco/datos-banco.component';
import { SueldoComponent } from '../sueldos/sueldo-cab/sueldo.component';
import { NovedadesMesComponent } from '../novedadesMes/novedades-mes/novedades-mes.component';
import { NovedadesPeriodoComponent } from '../novedadesPeriodo/novedades-periodo/novedades-periodo.component';
import { AfiliacionesCabComponent } from '../afiliaciones/afiliaciones-cab/afiliaciones-cab.component';
import { DatosEstadoNominaComponent } from '../datos-estadoNomina/datos-estado-nomina.component';
import { NominasEspecialesComponent } from '../nominasEspeciales/nominas-especiales/nominas-especiales.component';
import { HorariosTrabajoComponent } from '../horarios-trabajo/horarios-trabajo.component';
import { NovedadesTiemposComponent } from '../novedadesTiempos/novedades-tiempos/novedades-tiempos.component';
import { AusentismosCabComponent } from '../ausentismos/ausentismos-cab/ausentismos-cab.component';
import { ContingentesCabComponent } from '../contingentes/contingentes-cab/contingentes-cab.component';
import { DatosIIGGComponent } from '../datos-iigg/datos-iigg.component';
import { DeducionesIiggComponent } from '../deduccionesIIGG/deduciones-iigg/deduciones-iigg.component';
import { OtroEmpleadorComponent } from '../otroEmpleador/otro-empleador/otro-empleador.component';
import { SeguridadSocialComponent } from '../seguridad-social/seguridad-social.component';
import { setComponentName } from '../../../../global';
import { MomentSetService} from '../../../core/services/moment-set.service';

@Component({
  selector: 'app-personal-detail',
  templateUrl: './personal-detail.component.html',
  styleUrls: ['./personal-detail.component.css']
})
export class PersonalDetailComponent implements OnChanges, OnInit, OnDestroy {
  
  personal:any;
  personalId: any;
  permisoPersonal: boolean = false;
  permisoOrganizativo: boolean = false;
  permisoDireccion: boolean = false;
  permisoFamiliar: boolean = false;
  permisoIdentidad: boolean = false;
  permisoFecha: boolean = false;
  permisoContrato: boolean = false;
  permisoBanco: boolean = false;
  permisoSueldo: boolean = false;
  permisoNovFija: boolean = false;
  permisoNovPeriodo: boolean = false;
  permisoAfiliacion: boolean = false;
  permisoNomina: boolean = false;
  permisoHorario: boolean = false;
  permisoNovTiempo: boolean = false;
  permisoNomEspeciales: boolean = false;
  permisoIndemnizacion: boolean = false;
  permisoAusentismo: boolean = false;
  permisoContingente: boolean = false;
  permisoDatosIIGG: boolean = false;
  permisoDeduccionesIIGG: boolean = false;
  permisoOtroEmpleador: boolean = false;
  permisoSeguridadSocial: boolean = false;
  fechaslist: any;
  gruposLiquidaciones: any;
  
  @Input() personalCode;
  @Input() personalPar;

  @ViewChild(DatosOrganizativosComponent) componente12!: DatosOrganizativosComponent;
  @ViewChild(DireccionesComponent) componente13!: DireccionesComponent;
  @ViewChild(FamiliaresComponent) componente14!: FamiliaresComponent;
  @ViewChild(InfoIdentidadCabComponent) componente15!: InfoIdentidadCabComponent;
  @ViewChild(DatosFechasCabComponent) componente16!: DatosFechasCabComponent;
  @ViewChild(AfiliacionesCabComponent) componente17!: AfiliacionesCabComponent;
  @ViewChild(ContratosComponent) componente18!: ContratosComponent;
  @ViewChild(DatosBancoComponent) componente21!: DatosBancoComponent;
  @ViewChild(SueldoComponent) componente22!: SueldoComponent;
  @ViewChild(NovedadesMesComponent) componente23!: NovedadesMesComponent;
  @ViewChild(NovedadesPeriodoComponent) componente24!: NovedadesPeriodoComponent;
  @ViewChild(DatosEstadoNominaComponent) componente25!: DatosEstadoNominaComponent;
  @ViewChild(NominasEspecialesComponent) componente26!: NominasEspecialesComponent;
  @ViewChild(NominasEspecialesComponent) componente27!: NominasEspecialesComponent;
  @ViewChild(HorariosTrabajoComponent) componente31!: HorariosTrabajoComponent;
  @ViewChild(NovedadesTiemposComponent) componente32!: NovedadesTiemposComponent;
  @ViewChild(AusentismosCabComponent) componente33!: AusentismosCabComponent;
  @ViewChild(ContingentesCabComponent) componente34!: ContingentesCabComponent;
  @ViewChild(DatosIIGGComponent) componente41!: DatosIIGGComponent;
  @ViewChild(DeducionesIiggComponent) componente42!: DeducionesIiggComponent;
  @ViewChild(OtroEmpleadorComponent) componente43!: OtroEmpleadorComponent;
  @ViewChild(SeguridadSocialComponent) componente44!: SeguridadSocialComponent;

  constructor(private fechasSrv: DatosFechasService,
              private gruposLiquidacionService: GruposLiquidacionService,
              private spinnerService: SpinnerService,
              private momentService: MomentSetService) 
  {
    setComponentName('PersonalDetailComponent');
  }

  ngOnInit(): void 
  {
    //Activo el spinner
    this.spinnerService.show();

    this.personalId = this.personalPar.id;

    this.fechasSrv.getByPersonal(this.personalId, false).subscribe(
      data => 
    {
      data.forEach((currentValue,index,arr) => {
        currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
        currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        currentValue.fechaEvento = this.momentService.convertDateServer(currentValue.fechaEvento);  
      });      

      this.fechaslist = data;
    });

    //Grupo vigente
    this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).subscribe(
      data =>
    {
      data.periodoRetroactividadNavigation.fechaDd = this.momentService.convertDateServer(data.periodoRetroactividadNavigation.fechaDd);
      data.periodoRetroactividadNavigation.fechaHh = this.momentService.convertDateServer(data.periodoRetroactividadNavigation.fechaHh);
      data.periodoRetroactividadNavigation.fechaPago = this.momentService.convertDateServer(data.periodoRetroactividadNavigation.fechaPago);
      data.periodoActualNavigation.fechaDd = this.momentService.convertDateServer(data.periodoActualNavigation.fechaDd);
      data.periodoActualNavigation.fechaHh = this.momentService.convertDateServer(data.periodoActualNavigation.fechaHh);
      data.periodoActualNavigation.fechaPago = this.momentService.convertDateServer(data.periodoActualNavigation.fechaPago);

      this.gruposLiquidaciones = data;
    });
    
    this.verPermisos();
  }

  ngOnDestroy(): void {
    setComponentName('');
  }

  async verPermisos() : Promise<void>  
  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Ver Datos Personales")) this.permisoPersonal = true;
    if (permisos.includes("Ver Datos Organizativos")) this.permisoOrganizativo = true;
    if (permisos.includes("Ver Direcciones")) this.permisoDireccion = true;
    if (permisos.includes("Ver Familiares")) this.permisoFamiliar = true;
    if (permisos.includes("Ver Info Identidad")) this.permisoIdentidad = true;
    if (permisos.includes("Ver Datos Fechas")) this.permisoFecha = true;
    if (permisos.includes("Ver Afiliaciones")) this.permisoAfiliacion = true;
    if (permisos.includes("Ver Contratos")) this.permisoContrato = true;
    if (permisos.includes("Ver Datos Bancarios")) this.permisoBanco = true;
    if (permisos.includes("Ver Sueldo Basico")) this.permisoSueldo = true;
    if (permisos.includes("Ver Novedades Fijas")) this.permisoNovFija = true;
    if (permisos.includes("Ver Novedades Periodo")) this.permisoNovPeriodo = true;
    if (permisos.includes("Ver Nominas Especiales")) this.permisoNomEspeciales = true;
    if (permisos.includes("Ver Indemnizacion")) this.permisoIndemnizacion = true;
    if (permisos.includes("Ver Estado Nomina")) this.permisoNomina = true;
    if (permisos.includes("Ver Horarios de Trabajo")) this.permisoHorario = true;
    if (permisos.includes("Ver Novedades Tiempos")) this.permisoNovTiempo = true;
    if (permisos.includes("Ver Ausentismos")) this.permisoAusentismo = true;
    if (permisos.includes("Ver Contingentes")) this.permisoContingente = true;
    if (permisos.includes("Ver Datos IIGG")) this.permisoDatosIIGG = true;
    if (permisos.includes("Ver Deducciones IIGG")) this.permisoDeduccionesIIGG = true;
    if (permisos.includes("Ver Otro Empleador")) this.permisoOtroEmpleador = true;
    if (permisos.includes("Ver Seguridad Social")) this.permisoSeguridadSocial = true;
  }

  ngOnChanges(changes: SimpleChanges) 
  {
    if(changes.personalCode.currentValue != '') {
      this.personalId = this.personalPar.id;
      this.personal = this.personalPar;
    }
  }

  changeTab(tabsContainer, index) :void
  {
    tabsContainer.childNodes[0].childNodes.forEach(element => {
      element.className = "nav-link";
    });
    tabsContainer.childNodes[0].childNodes[index].className = "nav-link active";

    tabsContainer.childNodes[1].childNodes.forEach(element => {
      element.className = "tab-pane";
    });
    tabsContainer.childNodes[1].childNodes[index].className = "tab-pane active";
  }

  OnCargarHijo11()
  {
    //Cuando termina de cargar los datos personales desactivo el spinner
    this.spinnerService.hide();
  }
}
